<template>
  <Teleport to="body">
    <div
      v-if="store.showNewArtwork"
      class="fixed inset-0 w-full h-screen bg-black/25 sm:backdrop-blur-xs z-50"
    ></div>
    <Transition
      enter-active-class="slideInUp"
      leave-active-class="slideOutDown"
    >
      <div
        v-if="store.showNewArtwork"
        class="fixed h-auto inset-0 w-full bg-transparent z-80 flex md:items-center items-end justify-center"
      >
        <StepContainer v-if="user" :step-title="getStepTitle">
          <Transition name="slide" mode="out-in">
            <component :is="allSteps[step]!.component" :key="step"></component>
          </Transition>
        </StepContainer>
        <BaseNotLoggedIn @close="store.closeNewArtwork" v-else />
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, onMounted, shallowRef } from "vue";
import type { ArtworkStep } from "~~/types/artwork";
import price from "@/components/step/price.vue";
import title from "../step/title.vue";
import location from "../step/location.vue";
import artType from "../step/art-type.vue";
import previewSave from "../step/preview-save.vue";
import thumbnail from "../step/thumbnail.vue";
import type { AppUser } from "~~/types/user.js";

const store = useNewArtworkStore();

const user = useState<AppUser | null>("auth-user", () => null);

const allSteps = shallowRef<ArtworkStep[]>([
  {
    id: 1,
    title: "Title and description",
    step: 0,
    component: title,
    key: "new.title_description",
  },
  {
    id: 2,
    title: "Artwork type",
    step: 2,
    component: artType,
    key: "new.art_type",
  },
  {
    id: 3,
    title: "Artwork picture",
    step: 3,
    component: thumbnail,
    key: "new.artwork_thumbnail",
  },
  {
    id: 4,
    title: "Set price",
    step: 4,
    component: price,
    key: "new.set_price",
  },
  {
    id: 5,
    title: "Artwork location",
    step: 4,
    component: location,
    key: "new.artwork_location",
  },
  {
    id: 6,
    title: "Preview and save",
    step: 5,
    component: previewSave,
    key: "new.preview_and_save",
  },
]);
const step = computed<number>(() => store.currentStep);

const getStepTitle = computed<string>(() => allSteps.value[step.value]!.key);

onMounted(() => {
  store.updateTotalSteps(allSteps.value.length);
  store.getArtworkDraft();
});
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease-out;
}

.slide-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
